<template>
  <ModalComponent
    class="schedule-modal"
    :modal-class="`${showRef ? 'date-picker-modal' : ''}`"
    :model-value="showRef"
    :close="handleCloseModal"
    :max-width="65"
    :style-class="classModal"
    :style-class-contain="styleClassContain"
    @scroll-modal="onScroll"
  >
    <ModalHeader
      :class="`modal-header`"
      :title="getComponentUiText('app-scanning-schedule-modal-title-1')"
      @close="handleCloseModal"
    />
    <div
      class="tw-p-[40px] tw-flex tw-flex-col tw-gap-y-[30px] tw-overflow-auto tw-overflow-x-hidden"
    >
      <div class="tw-flex tw-flex-col tw-items-start tw-gap-y-[15px]">
        <div
          class="tw-text-[22px] tw-text-[#211F58] tw-font-[600] tw-leading-none"
        >
          {{ title }}
        </div>
        <div
          class="tw-text-[#231F20] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]"
        >
          {{ description }}
        </div>
      </div>

      <!-- Repeat -->
      <BaseInput
        id="repeat"
        v-model="formModel.repeat"
        :validation="vueValidate.repeat"
        :label="
          getComponentUiText('app-scanning-schedule-modal-filed-repeat-1')
        "
        :label-class="'tw-text-[#231F20]'"
        :class-name="'tw-mt-[0px]'"
        :col-title="4"
        :col-input="8"
      >
        <div class="dropdown">
          <BaseDropDown
            :id="'repeat'"
            v-model="formModel.repeat"
            :data="REPEAT_OPTIONS"
            :validation="vueValidate.repeat"
            :class-name="'gray-dropdown-container tw-h-[58px] autoFocus'"
            :placeholder="
              getComponentUiText(
                'app-scanning-schedule-modal-select-frequency-placeholder-1',
              )
            "
          />
        </div>
      </BaseInput>
      <div
        class="tw-border-0 tw-border-b tw-border-solid tw-border-[#EFF0F1]"
      />

      <DailyComponent
        v-if="formModel.repeat === REPEAT_OPTIONS_ID.daily"
        v-model="formModel.dataByRepeat.daily"
        :validation="vueValidate.dataByRepeat.daily"
      />

      <WeeklyComponent
        v-else-if="formModel.repeat === REPEAT_OPTIONS_ID.weekly"
        v-model="formModel.dataByRepeat.weekly"
        :validation="vueValidate.dataByRepeat.weekly"
      />

      <MonthlyComponent
        v-else-if="formModel.repeat === REPEAT_OPTIONS_ID.monthly"
        v-model="formModel.dataByRepeat.monthly"
        :validation="vueValidate.dataByRepeat.monthly"
      />

      <YearlyComponent
        v-else-if="formModel.repeat === REPEAT_OPTIONS_ID.yearly"
        v-model="formModel.dataByRepeat.yearly"
        :validation="vueValidate.dataByRepeat.yearly"
      />

      <div
        v-if="formModel.repeat"
        class="tw-border-0 tw-border-b tw-border-solid tw-border-[#EFF0F1]"
      />

      <!-- Starts -->
      <div>
        <BaseInput
          id="lock-status"
          v-model="formModel.starts"
          :validation="vueValidate.starts"
          :label="
            getComponentUiText('app-scanning-schedule-modal-filed-starts-1')
          "
          :label-class="'tw-text-[#231F20]'"
          :class-name="'tw-mt-[0px]'"
          :col-title="4"
          :col-input="8"
        >
          <DatePickInput
            v-model="formModel.starts"
            :placeholder="
              getComponentUiText(
                'app-scanning-schedule-modal-select-date-placeholder-1',
              )
            "
            :class-name="`placeholder:!tw-text-[13px]`"
            :focus="false"
            :validation="vueValidate.starts"
          />
        </BaseInput>
      </div>

      <!-- At -->
      <div>
        <BaseInput
          id="lock-status"
          v-model="formModel.at"
          :validation="vueValidate.at"
          :label="getComponentUiText('app-scanning-schedule-modal-filed-at-1')"
          :label-class="'tw-text-[#231F20]'"
          :class-name="'tw-mt-[0px]'"
          :col-title="4"
          :col-input="8"
        >
          <VueTimepicker
            v-model="formModel.at"
            format="hh:mm a"
            :placeholder="
              getComponentUiText(
                'app-scanning-schedule-modal-select-time-placeholder-1',
              )
            "
            class="tw-w-full"
            :input-class="{
              '!tw-w-full !tw-px-[20px] !tw-py-[18px] !tw-h-[56px] tw-rounded-[6px] tw-bg-[#F7F7F8] !tw-border-[#EFF0F1] tw-cursor-pointer !tw-font-[Poppins] !tw-text-[13px] !tw-font-[400] !tw-text-[#231F20] custom-placeholder': true,
              'is-invalid-input': vueValidate.at.$error,
            }"
            :minute-interval="15"
            hide-clear-button
          />
        </BaseInput>
      </div>

      <div
        class="tw-border-0 tw-border-b tw-border-solid tw-border-[#EFF0F1]"
      />

      <!-- Ends -->
      <div>
        <BaseInput
          id="ends"
          v-model="formModel.ends"
          :validation="
            formModel.ends.value === optionEndsSelected.on
              ? vueValidate.ends.until
              : formModel.ends.value === optionEndsSelected.after
                ? vueValidate.ends.count
                : vueValidate.ends.value
          "
          :label="
            getComponentUiText('app-scanning-schedule-modal-filed-ends-1')
          "
          :label-class="'tw-text-[#231F20]'"
          :class-name="'tw-mt-[0px]'"
          :col-title="4"
          :col-input="8"
        >
          <div
            class="tw-w-full tw-flex tw-gap-[33px] tw-items-center tw-mb-[30px]"
          >
            <BaseCheckbox
              :text="
                getComponentUiText(
                  'app-scanning-schedule-modal-filed-ends-on-1',
                )
              "
              :text-style="'tw-text-[13px] !tw-font-[400] tw-ml-[2px]'"
              color="#387DFF"
              :ticked="formModel.ends.value === optionEndsSelected.on"
              @selected="() => handleState(optionEndsSelected.on)"
              @unselected="() => handleState(optionEndsSelected.unselected)"
            />
            <WizardInputQuestion
              v-model="formModel.ends.until"
              :placeholder="
                getComponentUiText(
                  'app-scanning-schedule-modal-select-date-placeholder-1',
                )
              "
              :input-class="`tw-flex-1 placeholder:!tw-text-[13px] ${
                vueValidate.ends.until.$error ? 'is-invalid-input' : ''
              }`"
              :text-color="`${
                formModel.ends.value === optionEndsSelected.on ? '' : '#B7B7B7'
              }`"
              :focus="false"
              :type="INPUT_TYPE.Date"
              :class="'tw-ml-[32px]'"
              :col-class="'tw-w-[220px]'"
              :col-label-class="'tw-hidden'"
              @on:focus="() => (formModel.ends.value = optionEndsSelected.on)"
            ></WizardInputQuestion>
          </div>
          <div class="tw-full dropdown tw-flex tw-flex-col tw-gap-y-[30px]">
            <div
              class="tw-w-full tw-flex tw-items-center tw-gap-[53px] tw-flex-wrap"
            >
              <div class="tw-flex">
                <BaseCheckbox
                  :text="
                    getComponentUiText(
                      'app-scanning-schedule-modal-filed-ends-after-1',
                    )
                  "
                  :text-style="'tw-text-[13px] !tw-font-[400] tw-ml-[2px]'"
                  color="#387DFF"
                  :ticked="formModel.ends.value === optionEndsSelected.after"
                  @selected="() => handleState(optionEndsSelected.after)"
                  @unselected="() => handleState(optionEndsSelected.unselected)"
                />
              </div>
              <div class="tw-flex tw-items-center tw-gap-[20px]">
                <BaseInput
                  id="count"
                  v-model="formModel.ends.count"
                  type="number"
                  :placeholder="
                    getComponentUiText(
                      'app-scanning-schedule-modal-input-placeholder-1',
                    )
                  "
                  :input-class="'tw-w-[100px]'"
                  :class-name="'!tw-mt-0'"
                  :validation="
                    formModel.ends.value === optionEndsSelected.after &&
                    vueValidate.ends.count
                  "
                  @focus="
                    () => (formModel.ends.value = optionEndsSelected.after)
                  "
                  @update:model-value="
                    (val) => {
                      formModel.ends.count = val;
                    }
                  "
                  @blur="blurCount"
                  @keydown="preventNonNumeric"
                >
                  <template #feedback>
                    <div />
                  </template>
                </BaseInput>
                <div
                  class="tw-text-[13px] tw-font-[400] tw-text-[#231F20] tw-leading-normal"
                >
                  {{
                    getComponentUiText(
                      "app-scanning-schedule-modal-filed-occurrence(s)-1",
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="tw-flex">
              <BaseCheckbox
                :text="
                  getComponentUiText(
                    'app-scanning-schedule-modal-filed-ends-never-1',
                  )
                "
                :text-style="'tw-text-[13px] !tw-font-[400] tw-ml-[2px]'"
                color="#387DFF"
                :ticked="formModel.ends.value === optionEndsSelected.never"
                @selected="() => handleState(optionEndsSelected.never)"
                @unselected="() => handleState(optionEndsSelected.unselected)"
              />
            </div>
          </div>
        </BaseInput>
      </div>

      <!-- Button  -->
      <div class="tw-flex tw-items-center tw-justify-end tw-pt-[10px] tw-gap-3">
        <b-button
          v-if="isShowButtonRemoveSchedule && isScheduleMultiselect"
          ref="btnRef"
          :style="{ lineHeight: '90%', height: '39px', width: `${btnWidth}px` }"
          variant="primary"
          :class="`tw-min-w-max tw-shadow-none tw-text-[#387DFF] tw-bg-white tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]`"
          type="submit"
          @click="handleUpdateMultiselect(true)"
        >
          {{
            getComponentUiText(
              "app-scanning-schedule-modal-button-remove-multiselect-1",
            )
          }}
        </b-button>

        <b-button
          v-else-if="!isScheduleMultiselect && Boolean(scheduleData)"
          ref="btnScheduleRef"
          :style="{
            lineHeight: '90%',
            height: '39px',
            width: `${btnScheduleWidth}px`,
          }"
          variant="primary"
          :class="`tw-min-w-max tw-flex tw-items-center tw-justify-center tw-shadow-none tw-text-[#387DFF] tw-bg-white tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]`"
          type="submit"
          @click="`${handleUpdateModal(true)}`"
        >
          <div
            v-if="isUpdateSchedule && isRemoveScheduleRef"
            class="tw-h-[39px] tw-w-[39px] tw-text-black"
          >
            <!-- eslint-disable vue/no-unused-refs -->
            <LottieAnimation
              ref="anim"
              :animation-data="ProgressAnimationLight"
              :auto-play="true"
              :loop="true"
            />
          </div>
          <div v-else>
            {{
              isScheduleMultiselect
                ? "Remove schedules"
                : getComponentUiText(
                    "app-scanning-schedule-modal-button-remove-1",
                  )
            }}
          </div>
        </b-button>

        <b-button
          ref="btnRef"
          :style="{ lineHeight: '90%', height: '39px', width: `${btnWidth}px` }"
          variant="primary"
          class="tw-flex tw-items-center tw-justify-center"
          :class="`tw-min-w-max tw-shadow-none tw-bg-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]`"
          type="submit"
          @click="
            `${
              isScheduleMultiselect
                ? handleUpdateMultiselect(false)
                : handleUpdateModal(false)
            }`
          "
        >
          <div
            v-if="isUpdateSchedule && !isRemoveScheduleRef"
            class="tw-h-[39px] tw-w-[39px]"
          >
            <!-- eslint-disable vue/no-unused-refs -->
            <LottieAnimation
              ref="anim"
              :animation-data="ProgressAnimation"
              :auto-play="true"
              :loop="true"
            />
          </div>
          <div v-else>
            {{ buttonText }}
          </div>
        </b-button>
      </div>
    </div>
  </ModalComponent>
</template>

<script setup>
import { computed, nextTick, onMounted, ref } from "vue";
import Modal from "../common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import BaseInput from "../common/form/baseInput.vue";
import BaseDropDown from "../common/form/baseDropDown.vue";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import DailyComponent from "./dailyComponent.vue";
import WeeklyComponent from "./weeklyComponent.vue";
import MonthlyComponent from "./monthlyComponent.vue";
import YearlyComponent from "./yearlyComponent.vue";
import VueTimepicker from "vue3-timepicker";
import "vue3-timepicker/dist/VueTimepicker.css";
import {
  INPUT_TYPE,
  optionDailySelected,
  optionEndsSelected,
  optionMonthlySelected,
  optionYearlySelected,
  REPEAT_OPTIONS,
  REPEAT_OPTIONS_ID,
  TYPE_SCHEDULE,
} from "@/utils/constants";
import BaseCheckbox from "../common/form/baseCheckbox.vue";
import DatePickInput from "../common/datePickInput.vue";
import {
  convertRRuleStringToSchedule,
  convertScheduleToRRuleString,
} from "@/utils/rruleUtils.ts";
import store from "@/store";
import { ToastVariant } from "@/interfaces/common/IToastMessage";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { watch } from "vue";
import cloneDeep from "lodash/cloneDeep";
import WizardInputQuestion from "../wizard/wizardInputQuestion.vue";
import ModalComponent from "../common/modalComponent.vue";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import ProgressAnimationLight from "../../assets/animation/progress_light.json";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  buttonText: {
    type: String,
    required: true,
  },
  scanTargetType: {
    type: String,
    default: TYPE_SCHEDULE.webservices,
  },
  targetId: {
    type: [Number, String, null],
    required: true,
  },
  selectedRowsWebServices: {
    type: Array,
    default: () => [],
  },
  selectedRowsDomains: {
    type: Array,
    default: () => [],
  },
  isScheduleMultiselect: {
    type: Boolean,
    required: false,
    default: false,
  },
  isShowButtonRemoveSchedule: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const emit = defineEmits([
  "update:show",
  "add:member",
  "update:value",
  "update:answer",
  "onUpdate",
]);

const initialForm = {
  repeat: "",
  dataByRepeat: {
    daily: {
      value: "",
      interval: null,
    },
    weekly: {
      value: "",
      day: null,
      interval0: null,
    },
    monthly: {
      value: "",
      day: null,
      interval0: null,
      the: null,
      order: null,
      date: null,
      interval1: null,
    },
    yearly: {
      value: "",
      interval: null,
      month0: null,
      day: null,
      order: null,
      date: null,
      month1: null,
    },
  },
  starts: "",
  at: "",
  ends: {
    value: null,
    until: null,
    count: null,
  },
};
// Form modal and validation.
const formModel = ref(cloneDeep(initialForm));
const isUpdateSchedule = ref(false);
const btnRef = ref(null);
const btnScheduleRef = ref(null);
const btnWidth = ref(0);
const btnScheduleWidth = ref(0);

const scheduleData = computed(() =>
  store.getters["Scanning/GET_SCHEDULED_ITEM"]({
    type: props.scanTargetType,
    id: props.targetId,
  }),
);

const showRef = ref(props.show);

onMounted(() => {
  formatData();
});

const formatData = () => {
  try {
    const rrule = scheduleData.value?.rrule;
    if (rrule) {
      formModel.value = convertRRuleStringToSchedule(rrule);
    } else {
      formModel.value = cloneDeep(initialForm);
    }
  } catch (error) {
    formModel.value = cloneDeep(initialForm);
    showError(getComponentUiText("app-exception-handler-error-unknown-error"));
  }
};

watch(
  () => scheduleData.value,
  (value) => {
    formatData();
  },
);

const onScroll = () => {
  eventEmitter.emit(EmitterEvents.SCROLL_MODAL);
};

const showError = (message) => {
  const emitData = {
    variant: ToastVariant.ERROR,
    message,
  };
  eventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const clearData = () => {
  formatData();
  vueValidate.value.$reset();
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  emit("update:show", showRef.value);
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

const regexAtTime = (value = "") => {
  const regex = /^([1-9]|0[1-9]|1[0-2]):[0-5][0-9] ([AaPp][Mm])$/gim;
  return regex.test(value.trim());
};

const rules = {
  repeat: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  starts: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  at: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      regexAtTime,
    ),
  },
  ends: {
    value: {
      required: helpers.withMessage(
        () => getComponentUiText("app-common-form-value-required-error-1"),
        required,
      ),
    },
    until: computed(() => ({
      required:
        formModel.value.ends.value === optionEndsSelected.on
          ? helpers.withMessage(
              () =>
                getComponentUiText("app-common-form-value-required-error-1"),
              required,
            )
          : false,
    })),
    count: computed(() => ({
      required:
        formModel.value.ends.value === optionEndsSelected.after
          ? helpers.withMessage(
              () =>
                getComponentUiText("app-common-form-value-required-error-1"),
              required,
            )
          : false,
    })),
  },
  dataByRepeat: {
    daily: {
      value: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.daily
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      interval: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.daily &&
          formModel.value.dataByRepeat.daily.value === optionDailySelected.every
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
    },
    weekly: {
      value: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.weekly
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      interval: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.weekly
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
    },
    monthly: {
      value: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.monthly
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      day: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.monthly &&
          formModel.value.dataByRepeat.monthly.value ===
            optionMonthlySelected.day
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      interval0: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.monthly &&
          formModel.value.dataByRepeat.monthly.value ===
            optionMonthlySelected.day
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      order: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.monthly &&
          formModel.value.dataByRepeat.monthly.value ===
            optionMonthlySelected.the
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      date: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.monthly &&
          formModel.value.dataByRepeat.monthly.value ===
            optionMonthlySelected.the
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      interval1: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.monthly &&
          formModel.value.dataByRepeat.monthly.value ===
            optionMonthlySelected.the
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
    },
    yearly: {
      value: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.yearly
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      interval: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.yearly
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      month0: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.yearly &&
          formModel.value.dataByRepeat.yearly.value === optionYearlySelected.on
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      day: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.yearly &&
          formModel.value.dataByRepeat.yearly.value === optionYearlySelected.on
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      order: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.yearly &&
          formModel.value.dataByRepeat.yearly.value ===
            optionYearlySelected.onThe
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      date: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.yearly &&
          formModel.value.dataByRepeat.yearly.value ===
            optionYearlySelected.onThe
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
      month1: computed(() => ({
        required:
          formModel.value.repeat === REPEAT_OPTIONS_ID.yearly &&
          formModel.value.dataByRepeat.yearly.value ===
            optionYearlySelected.onThe
            ? helpers.withMessage(
                () =>
                  getComponentUiText("app-common-form-value-required-error-1"),
                required,
              )
            : false,
      })),
    },
  },
};

const vueValidate = useVuelidate(rules, formModel);

const handleState = (value) => {
  formModel.value.ends.value = value;
  emit("onUpdate", value);
  emit("update:answer", value);
};

const blurCount = () => {
  const val = formModel.value.ends.count;
  if (val) {
    const temp = Math.max(1, Math.min(100, val));
    formModel.value.ends.count = temp;
  }
};
const preventNonNumeric = (evt) => {
  if (evt.key.length === 1 && !/[0-9]/.test(evt.key)) {
    evt.preventDefault();
  }
};
const isRemoveScheduleRef = ref(false);
const handleUpdateModal = async (isRemoveSchedule) => {
  await nextTick();
  if (btnRef.value || btnScheduleRef.value) {
    btnWidth.value = btnRef.value?.$el?.offsetWidth;
    btnScheduleWidth.value = btnScheduleRef.value?.$el?.offsetWidth;
  }
  isRemoveScheduleRef.value = isRemoveSchedule;
  isUpdateSchedule.value = true;
  try {
    const isEdit = Boolean(scheduleData.value);
    if (!isEdit && isRemoveSchedule) {
      handleCloseModal();
      return;
    }
    const result = await vueValidate.value.$validate();
    if (result) {
      const form = {
        ...formModel.value,
        at: formModel.value.at,
        dataByRepeat: {
          ...formModel.value.dataByRepeat,
          monthly: {
            ...formModel.value.dataByRepeat.monthly,
            interval:
              formModel.value.dataByRepeat.monthly[
                `interval${formModel.value.dataByRepeat.monthly?.value}`
              ],
          },
          yearly: {
            ...formModel.value.dataByRepeat.yearly,
            month:
              formModel.value.dataByRepeat.yearly[
                `month${formModel.value.dataByRepeat.yearly?.value}`
              ],
          },
        },
      };
      const ruleString = convertScheduleToRRuleString(form);
      const isEdit = Boolean(scheduleData.value);
      const data = {
        targetId: props.targetId,
        rrule: ruleString,
        scheduleId: scheduleData.value?.scheduleId,
      };
      if (isRemoveSchedule) {
        if (btnRef.value) {
          btnWidth.value = btnRef.value.$el?.offsetWidth;
        }
        data.isArchived = isRemoveSchedule;
        delete data.rrule;
      }
      const isSuccess = await store.dispatch("Scanning/actionScheduleScan", {
        isEdit,
        scanTargetType: props.scanTargetType,
        data: [data],
      });
      if (isSuccess) {
        if (props.scanTargetType === TYPE_SCHEDULE.webservices) {
          await store.dispatch("Scanning/fetchReportScheduleWebServices");
        } else {
          await store.dispatch("Scanning/fetchReportScheduleDomain");
        }
        handleCloseModal();
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    isUpdateSchedule.value = false;
  }
};

const listScansReportScheduleWebServices = computed(() => {
  return store.state.Scanning.scanReportScheduleWebServices;
});

const listScansReportScheduleDomains = computed(() => {
  return store.state.Scanning.scanReportScheduleDomains;
});

const domainIdsDoneSelectedScanTarget = computed(() => {
  const idsDomainScheduled =
    listScansReportScheduleDomains.value.length > 0
      ? listScansReportScheduleDomains.value.map(
          (service) => service.inputs.domainIds[0],
        )
      : [];
  return props.selectedRowsDomains.filter((service) =>
    idsDomainScheduled.includes(Number(service)),
  );
});

const webServiceIdsDoneSelectedScanTarget = computed(() => {
  const idsWebServiceScheduled =
    listScansReportScheduleWebServices.value.length > 0
      ? listScansReportScheduleWebServices.value.map(
          (service) => service.inputs.webServiceIds[0],
        )
      : [];
  return props.selectedRowsWebServices.filter((service) =>
    idsWebServiceScheduled.includes(Number(service)),
  );
});

const getScheduleId = (type, targetId) => {
  return store.getters["Scanning/GET_SCHEDULED_ITEM"]({
    type,
    id: targetId,
  })?.scheduleId;
};

const handleUpdateMultiselect = async (isRemoveSchedule) => {
  await nextTick();
  if (btnRef.value || btnScheduleRef.value) {
    btnWidth.value = btnRef.value.$el?.offsetWidth;
    btnScheduleWidth.value = btnScheduleRef.value.$el?.offsetWidth;
  }
  isUpdateSchedule.value = true;
  try {
    if (isRemoveSchedule) {
      if (
        props.selectedRowsDomains.length > 0 &&
        domainIdsDoneSelectedScanTarget.value.length > 0
      ) {
        await store.dispatch("Scanning/actionScheduleScan", {
          isEdit: true,
          scanTargetType: TYPE_SCHEDULE.domains,
          data: domainIdsDoneSelectedScanTarget.value.map((id) => ({
            targetId: id,
            isArchived: true,
            scheduleId: getScheduleId(TYPE_SCHEDULE.domains, id),
          })),
        });
        const isRemove = await store.dispatch("Scanning/actionScheduleScan", {
          isDelete: true,
          scanTargetType: TYPE_SCHEDULE.domains,
          data: domainIdsDoneSelectedScanTarget.value.map((id) => ({
            targetId: id,
            scheduleId: getScheduleId(TYPE_SCHEDULE.domains, id),
          })),
        });
        if (isRemove)
          await store.dispatch("Scanning/fetchReportScheduleDomain");
      }
      if (
        props.selectedRowsWebServices.length > 0 &&
        webServiceIdsDoneSelectedScanTarget.value.length > 0
      ) {
        await store.dispatch("Scanning/actionScheduleScan", {
          isEdit: true,
          scanTargetType: TYPE_SCHEDULE.webservices,
          data: webServiceIdsDoneSelectedScanTarget.value.map((id) => ({
            targetId: id,
            isArchived: true,
            scheduleId: getScheduleId(TYPE_SCHEDULE.webservices, id),
          })),
        });
        const isRemove = await store.dispatch("Scanning/actionScheduleScan", {
          isDelete: true,
          scanTargetType: TYPE_SCHEDULE.webservices,
          data: webServiceIdsDoneSelectedScanTarget.value.map((id) => ({
            targetId: id,
            scheduleId: getScheduleId(TYPE_SCHEDULE.webservices, id),
          })),
        });

        if (isRemove)
          await store.dispatch("Scanning/fetchReportScheduleWebServices");
      }
      handleCloseModal();
      return;
    }
    const result = await vueValidate.value.$validate();

    if (result) {
      const form = {
        ...formModel.value,
        at: formModel.value.at,
        dataByRepeat: {
          ...formModel.value.dataByRepeat,
          monthly: {
            ...formModel.value.dataByRepeat.monthly,
            interval:
              formModel.value.dataByRepeat.monthly[
                `interval${formModel.value.dataByRepeat.monthly?.value}`
              ],
          },
          yearly: {
            ...formModel.value.dataByRepeat.yearly,
            month:
              formModel.value.dataByRepeat.yearly[
                `month${formModel.value.dataByRepeat.yearly?.value}`
              ],
          },
        },
      };
      const ruleString = convertScheduleToRRuleString(form);
      if (props.selectedRowsDomains.length > 0) {
        if (domainIdsDoneSelectedScanTarget.value.length > 0) {
          await store.dispatch("Scanning/actionScheduleScan", {
            isEdit: true,
            scanTargetType: TYPE_SCHEDULE.domains,
            data: domainIdsDoneSelectedScanTarget.value.map((id) => ({
              targetId: id,
              isArchived: true,
              scheduleId: getScheduleId(TYPE_SCHEDULE.domains, id),
            })),
          });
          await store.dispatch("Scanning/actionScheduleScan", {
            isDelete: true,
            scanTargetType: TYPE_SCHEDULE.domains,
            data: domainIdsDoneSelectedScanTarget.value.map((id) => ({
              targetId: id,
              scheduleId: getScheduleId(TYPE_SCHEDULE.domains, id),
            })),
          });
        }
        const isSuccess = await store.dispatch("Scanning/actionScheduleScan", {
          isEdit: false,
          scanTargetType: TYPE_SCHEDULE.domains,
          data: props.selectedRowsDomains.map((id) => ({
            targetId: id,
            rrule: ruleString,
            scheduleId: getScheduleId(TYPE_SCHEDULE.domains, id),
          })),
        });
        if (isSuccess) {
          await store.dispatch("Scanning/fetchReportScheduleDomain");
          handleCloseModal();
        }
      }
      if (props.selectedRowsWebServices.length > 0) {
        if (webServiceIdsDoneSelectedScanTarget.value.length > 0) {
          await store.dispatch("Scanning/actionScheduleScan", {
            isEdit: true,
            scanTargetType: TYPE_SCHEDULE.webservices,
            data: webServiceIdsDoneSelectedScanTarget.value.map((id) => ({
              targetId: id,
              isArchived: true,
              scheduleId: getScheduleId(TYPE_SCHEDULE.webservices, id),
            })),
          });
          await store.dispatch("Scanning/actionScheduleScan", {
            isDelete: true,
            scanTargetType: TYPE_SCHEDULE.webservices,
            data: webServiceIdsDoneSelectedScanTarget.value.map((id) => ({
              targetId: id,
              scheduleId: getScheduleId(TYPE_SCHEDULE.webservices, id),
            })),
          });
        }
        const isSuccess = await store.dispatch("Scanning/actionScheduleScan", {
          isEdit: false,
          scanTargetType: TYPE_SCHEDULE.webservices,
          data: props.selectedRowsWebServices.map((id) => ({
            targetId: id,
            rrule: ruleString,
            scheduleId: getScheduleId(TYPE_SCHEDULE.webservices, id),
          })),
        });
        if (isSuccess) {
          await store.dispatch("Scanning/fetchReportScheduleWebServices");
          handleCloseModal();
        }
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    isUpdateSchedule.value = false;
  }
};

const classModal = {
  background: "rgba(35, 31, 32, 0.5)",
};

const styleClassContain = computed(() => {
  return {
    "border-radius": "4px",
    "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
    overflow: "auto",
  };
});
</script>

<style scoped>
.up {
  transform: rotate(270deg);
}

.down {
  transform: rotate(180deg);
}

.your-awesome-timepicker {
  height: 56px;
  padding: 50px;
  margin: 50px;
}

.schedule-modal {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
}

@media (max-width: 768px) {
  .responsiveInput {
    width: 200px;
  }
}

:deep(.custom-placeholder::placeholder) {
  color: #b7b7b7 !important;
  font-size: 13px;
}
:deep(.is-invalid-input) {
  border: 1px solid #f7553c !important;
  background: #fee5e2 !important;

  &::after {
    content: "";
  }
}
</style>
